import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, Shield, ChevronRight } from 'lucide-react';
import { useSafetyStore } from '../../stores/safetyStore';
import { useUIStore } from '../../stores/uiStore';

export function SafetyScreen() {
  const navigate = useNavigate();
  const { settings, fetchSettings, toggleSecurity } = useSafetyStore();
  const { addToast } = useUIStore();

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const handleToggle = async () => {
    const newState = !settings?.isEnabled;
    await toggleSecurity(newState);
    addToast(newState ? 'Охрана включена' : 'Охрана выключена', 'success');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900">Безопасность</h1>
            
            <button
              onClick={() => navigate('/safety/settings')}
              className="p-2 rounded-full hover:bg-gray-100"
            >
              <Settings className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-6">
        {/* Security Card */}
        <div className={`rounded-2xl p-6 shadow-sm mb-6 ${
          settings?.isEnabled 
            ? 'bg-gradient-to-r from-green-500 to-green-600' 
            : 'bg-gradient-to-r from-gray-400 to-gray-500'
        }`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                <Shield className="w-6 h-6 text-white" />
              </div>
              
              <div>
                <h2 className="text-xl font-bold text-white">Охранная система</h2>
                <p className="text-white/80 text-sm">
                  {settings?.isEnabled ? 'Активна' : 'Отключена'}
                </p>
              </div>
            </div>
            
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={settings?.isEnabled || false}
                onChange={handleToggle}
                className="sr-only peer"
              />
              <div className="w-14 h-7 bg-white/30 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-white"></div>
            </label>
          </div>
        </div>

        {/* Stats */}
        <div className="bg-white rounded-xl shadow-sm p-4 mb-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-4 bg-gray-50 rounded-xl">
              <p className="text-2xl font-bold text-gray-900">
                {settings?.deviceList?.length || 0}
              </p>
              <p className="text-sm text-gray-500">Датчиков</p>
            </div>
            
            <div className="text-center p-4 bg-gray-50 rounded-xl">
              <p className="text-2xl font-bold text-gray-900">
                {settings?.isEnabled ? 'Да' : 'Нет'}
              </p>
              <p className="text-sm text-gray-500">Активна</p>
            </div>
          </div>
        </div>

        {/* Settings Link */}
        <button
          onClick={() => navigate('/safety/settings')}
          className="w-full flex items-center justify-between p-4 bg-white rounded-xl shadow-sm hover:bg-gray-50"
        >
          <span className="font-medium text-gray-900">Настроить датчики</span>
          <ChevronRight className="w-5 h-5 text-gray-400" />
        </button>
      </div>
    </div>
  );
}
